module.exports = __webpack_public_path__ + "static/media/29150034-min.d749d846.jpg";